let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6b5jR")).then(() => parcelRequire('hLzsc'));